/**
 * @description
 * Asynchronously wait for a specified duration inside an async function using the `await` syntax
 *
 * @param duration
 */
export const awaitTimeout = async (duration: number):Promise<typeof setTimeout> => new Promise((res) => setTimeout(res, duration));
